/** Beautified MPS circular emblem (public/school-logo.png). */
export function schoolLogoSrc() {
  return `${process.env.PUBLIC_URL || ''}/school-logo.png`;
}
